@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap');
@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --font-body: 'Inter', system-ui, sans-serif;
  --font-heading: 'Space Grotesk', system-ui, sans-serif;
  --font-label: 'Inter', system-ui, sans-serif;

  --background-50: 0.99 0.005 250;
  --background-100: 0.97 0.01 250;
  --background-200: 0.92 0.015 250;
  --background-300: 0.85 0.02 250;
  --background-400: 0.78 0.025 250;
  --background-500: 0.70 0.03 250;
  --background-600: 0.60 0.035 250;
  --background-700: 0.50 0.04 250;
  --background-800: 0.40 0.045 250;
  --background-900: 0.30 0.05 250;
  --background-950: 0.20 0.055 250;

  --primary-50: 0.95 0.03 245;
  --primary-100: 0.90 0.05 245;
  --primary-200: 0.85 0.07 245;
  --primary-300: 0.78 0.09 245;
  --primary-400: 0.70 0.11 245;
  --primary-500: 0.62 0.13 245;
  --primary-600: 0.55 0.14 245;
  --primary-700: 0.48 0.13 245;
  --primary-800: 0.40 0.12 245;
  --primary-900: 0.30 0.11 245;
  --primary-950: 0.20 0.10 245;

  --accent-50: 0.95 0.03 170;
  --accent-100: 0.90 0.05 170;
  --accent-200: 0.85 0.07 170;
  --accent-300: 0.78 0.09 170;
  --accent-400: 0.70 0.11 170;
  --accent-500: 0.62 0.13 170;
  --accent-600: 0.55 0.12 170;
  --accent-700: 0.48 0.11 170;
  --accent-800: 0.40 0.10 170;
  --accent-900: 0.30 0.09 170;
  --accent-950: 0.20 0.08 170;

  --secondary-50: 0.95 0.02 240;
  --secondary-100: 0.90 0.03 240;
  --secondary-200: 0.85 0.04 240;
  --secondary-300: 0.78 0.05 240;
  --secondary-400: 0.70 0.06 240;
  --secondary-500: 0.62 0.07 240;
  --secondary-600: 0.55 0.08 240;
  --secondary-700: 0.48 0.07 240;
  --secondary-800: 0.40 0.06 240;
  --secondary-900: 0.30 0.05 240;
  --secondary-950: 0.20 0.04 240;

  --foreground-50: 0.95 0.01 250;
  --foreground-100: 0.90 0.015 250;
  --foreground-200: 0.85 0.02 250;
  --foreground-300: 0.78 0.025 250;
  --foreground-400: 0.70 0.03 250;
  --foreground-500: 0.60 0.035 250;
  --foreground-600: 0.50 0.04 250;
  --foreground-700: 0.40 0.045 250;
  --foreground-800: 0.30 0.05 250;
  --foreground-900: 0.25 0.055 250;
  --foreground-950: 0.15 0.06 250;
}

@layer base {
  body {
    font-family: var(--font-body);
    background-color: oklch(var(--background-50));
    color: oklch(var(--foreground-950));
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}

@layer utilities {
  .animate-fade-in {
    animation: fadeIn 0.8s ease-out forwards;
  }
  .animate-fade-in-up {
    animation: fadeInUp 0.7s ease-out forwards;
  }
  .animate-fade-in-down {
    animation: fadeInDown 0.7s ease-out forwards;
  }
  .animate-scale-in {
    animation: scaleIn 0.6s ease-out forwards;
  }
  .animate-slide-in-left {
    animation: slideInLeft 0.7s ease-out forwards;
  }
  .animate-slide-in-right {
    animation: slideInRight 0.7s ease-out forwards;
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-16px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes slideInLeft {
  from { opacity: 0; transform: translateX(-30px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideInRight {
  from { opacity: 0; transform: translateX(30px); }
  to { opacity: 1; transform: translateX(0); }
}

.honeypot-field {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  opacity: 0;
}